export default __webpack_public_path__ + "static/media/Locomeal.0cd8f4dc.png";